<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContestApplication_editTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="data-value">
            <label>{{'bcContestApplication_lblStudent' | translate}}</label>
            <div>{{application?.StudentName}} ({{application?.StudentUpn}})</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestApplication_lblProgram' | translate}}</label>
            <div>{{application?.Program}}</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestApplication_lblSubject' | translate}}</label>
            <div>{{application?.SubjectName}} ({{application?.SubjectCode}})</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestApplication_lblAlgorithmResult' | translate}}</label>
            <div>{{resultDisplayFn(application?.AlgorithmResult)}}</div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'bcContestApplication_lblResult' | translate}}</label>
            <app-select [(ngModel)]="result"
                        [options]="availableResults"
                        [required]="true"
                        [displayFn]="resultDisplayFn"
                        name="result">
            </app-select>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button">{{'dialog_close' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving || !form.valid">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>
</div>
